import { PrimaryButtonRouterLink } from 'components/Button';
import { CmsApiStickyHeaderLinksBlockData } from 'modules/cms/api/types/CmsApiStickyHeaderLinks';
import { isEmpty } from 'utils/functional';
import { isUrlWithProtocol } from 'utils/url';

import { CmsStickyHeaderLinks } from './CmsStickyHeaderLinks';
import { CmsStickyHeaderLinksBlockExternalLink } from './CmsStickyHeaderLinksBlockExternalLink';

type Props = {
  data: CmsApiStickyHeaderLinksBlockData;
};

export function CmsStickyHeaderLinksBlock({
  data: { links, buttonText, buttonUrl },
}: Props) {
  const hasButton = !isEmpty(buttonUrl) && !isEmpty(buttonText);
  return (
    <CmsStickyHeaderLinks
      links={links}
      button={
        hasButton &&
        (buttonUrl && isUrlWithProtocol(buttonUrl) ? (
          <CmsStickyHeaderLinksBlockExternalLink href={buttonUrl}>
            {buttonText}
          </CmsStickyHeaderLinksBlockExternalLink>
        ) : (
          <PrimaryButtonRouterLink to={buttonUrl}>
            {buttonText}
          </PrimaryButtonRouterLink>
        ))
      }
    />
  );
}
